// Components
const ModalReminderNote = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ "@/app/views/main-view/general-info/modals/modal-reminder-note/modal-reminder-note.vue"
    );
const ModalAddEditReminder = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ "@/app/views/main-view/general-info/modals/modal-add-edit-reminder/modal-add-edit-reminder.vue"
    );

// Mixins
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Services
import reminderService from "@/app/services/main/reminder/reminder-service.js";

// Third party libraries
import { format } from "date-fns";
import DatePicker from "vue2-datepicker";

export default {
    name: "ReminderTableComponent",
    components: {
        DatePicker,
        ModalReminderNote,
        ModalAddEditReminder,
    },
    mixins: [GoogleAnalyticsMixins, toastMessageMixins, userMixins, tableMixins, switchPetMixins, dateMixins],
    data() {
        return {
            // loaders
            isAPILoading: false,
            isAddModalLoading: false,
            // table
            theads: [
                { name: null, sortLabel: null, style: "min-width: 10%;" },
                {
                    name: "Type",
                    sortLabel: "type",
                    isDesc: false,
                    style: "min-width: 15%;",
                    hasSearch: true,
                    searchLabel: "f_type",
                },
                {
                    name: "Note",
                    sortLabel: "note",
                    isDesc: false,
                    style: "min-width: 20%;",
                    hasSearch: true,
                    searchLabel: "f_note",
                },
                {
                    name: "Schedule",
                    sortLabel: "reminderDate",
                    isDesc: true,
                    style: "min-width: 20%;",
                    hasScheduleSearch: true,
                    searchLabel: "f_schedule",
                },
                {
                    name: "Frequency",
                    sortLabel: "frequency",
                    isDesc: false,
                    style: "min-width: 15%;",
                    hasFreuqncySearch: true,
                    searchLabel: "f_frequency",
                },
                {
                    name: "Status",
                    sortLabel: "status",
                    isDesc: false,
                    style: "min-width: 10%;",
                    hasStatusSearch: true,
                    searchLabel: "f_status",
                },
            ],
            // sorting
            desc: true,
            // modal
            modalContent: null,
            frequencyList: [
                { name: "Once", code: "P0D" },
                { name: "Weekly", code: "P1W" },
                { name: "Fortnigthly", code: "P2W" },
                { name: "Monthly", code: "P1M" },
                { name: "Quarterly", code: "P3M" },
                { name: "Annually", code: "P1Y" },
            ],
            statusList: [
                { name: "Active", code: "A", value: "ACTIVE" },
                { name: "Inactive", code: "I", value: "INACTIVE" },
            ],
            selectedStatus: "ACTIVE",
            dateRange: null,
            fileFormat: "",
        };
    },
    created() {
        this.columnsFilter["f_status"] = this.selectedStatus;
        this.getTableContent(this.page, this.limit, this.sortBy, (this.desc = false));
    },
    methods: {
        refreshActivePetData() {
            this.columnsFilter["f_status"] = this.selectedStatus;
            this.getTableContent(this.page, this.limit, this.sortBy, (this.desc = false));
        },
        getTableContent(
            page = this.page,
            limit = this.isDashboard ? 5 : this.limit,
            sortBy = this.sortBy,
            desc = this.desc
        ) {
            this.getReminderList({ page, limit, sortBy, desc });
        },
        getReminderList(queryParams) {
            queryParams["f_petId"] = this.getActivePet.id;
            if (this.columnsFilter["f_type"]) {
                queryParams["f_type"] = this.columnsFilter["f_type"];
            }
            if (this.columnsFilter["f_note"]) {
                queryParams["f_note"] = this.columnsFilter["f_note"];
            }
            if (this.columnsFilter["f_frequency"]) {
                queryParams["f_frequency"] = this.columnsFilter["f_frequency"];
            }
            if (this.columnsFilter["f_status"]) {
                queryParams["f_status"] = this.columnsFilter["f_status"];
            }
            if (this.columnsFilter["f_schedule"] && this.columnsFilter["f_schedule"][0]) {
                queryParams["f_startDate"] = format(new Date(this.columnsFilter["f_schedule"][0]), "yyyy-MM-dd");
                queryParams["f_endDate"] = format(new Date(this.columnsFilter["f_schedule"][1]), "yyyy-MM-dd");
            }

            this.isAPILoading = true;

            reminderService.getReminderLists(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data,
                        paginationData: res.data.pagination,
                    };
                    this.isAPILoading = false;
                } else {
                    this.isAPILoading = false;
                    const { ERROR_GET_REMINDER_CLUB } = this.toastMessages.reminder();
                    this.showAPIErrorToast(ERROR_GET_REMINDER_CLUB, res);
                }
            });
        },
        refreshTableContent() {
            this.getTableContent(this.page, this.limit, null, true);
        },
        displayDate(date) {
            return this.utcConvertToZonedTime(date, 'dd-MMM-yyyy hh:mm a', true);
        },
        displayFrequency(code) {
            return this.frequencyList.find((frequency) => frequency.code === code).name;
        },
        displayStatus(s) {
            return this.statusList.find((status) => status.code === s).name;
        },
        showReminderNoteModal(reminder) {
            this.$refs.modalReminderNote.show(reminder);
        },
        showAddEditReminderModal(action, reminder) {
            this.$refs.modalAddEditReminder.show({ action, reminder, frequencyList: this.frequencyList });
        },
    },
};
